<div class="toggle-wrapper">
  <div class="text-block">
    <strong class="semi-bold"> Are there known potential hazards? </strong>
  </div>
  <curbnturf-toggle [selected]="selected()" (clicked)="togglePotentialHazards()"> </curbnturf-toggle>
</div>

<div *ngIf="selected()">
  <textarea
    [formControl]="potentialHazardDescription"
    placeholder="The host has indicated there could be dangerous plants, animals, or land elements/features. Please contact host if you have any questions regarding any potential hazards."
  ></textarea>
</div>
